import { render, staticRenderFns } from "./big_index.vue?vue&type=template&id=6e8457e1&scoped=true"
import script from "./big_index.vue?vue&type=script&lang=js"
export * from "./big_index.vue?vue&type=script&lang=js"
import style0 from "./big_index.vue?vue&type=style&index=0&id=6e8457e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8457e1",
  null
  
)

export default component.exports